import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/assessment_search.svg'


const _hoisted_1 = { class: "hover-search-modal" }
const _hoisted_2 = { class: "tw-flex tw-text-[#211F58] tw-text-[14px] tw-not-italic tw-font-[500] tw-leading-[14px]" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "tw-pr-[9px] tw-cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_4 = { class: "tw-font-[400] tw-text-[11px] tw-text-[#B7B7B7]" }
const _hoisted_5 = { class: "tw-text-[11px] line-height-100 tw-rounded-b-[6px] tw-overflow-y-auto tw-text-[#211F58] tw-font-medium tw-px-[16px]" }
const _hoisted_6 = {
  key: 1,
  class: "tw-flex tw-items-center tw-pb-[16px] tw-px-[16px]"
}

import store from "@/store";
import { getComponentUiText } from "@/utils/utilities";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'modalHoverSearchAssessment',
  props: {
  isSearchModalAssessment: {
    type: Boolean,
    required: false,
    default: true,
  },
  searchTypeId: {
    type: String,
    required: false,
    default: "clinput",
  },
  customClass: {
    type: String,
    required: false,
    default: "",
  },
  isVendorAssessment: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["openSearchModal", "updateCurrentValueSearch"],
  setup(__props, { emit }) {

const props = __props;





const openSearchModal = () => {
  emit("openSearchModal");
};

const listResentSearch = computed(() => {
  if (props.isVendorAssessment) return store.state.Vendor.recentSearch;
  else return store.getters["Assessment/getRecentSearch"](props.searchTypeId);
});

const clearRecentSearch = () => {
  if (props.isVendorAssessment) store.commit("Vendor/CLEAR_RECENT_SEARCH");
  else {
    store.dispatch("Assessment/clearRecentSearch", {
      searchTypeId: props.searchTypeId,
    });
  }
};

const onClickItemResentSearch = (e: any) => {
  emit("updateCurrentValueSearch", e.target.innerText);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([__props.customClass, "tw-w-full tw-bg-[#ffffff] tw-pb-[2px] tw-h-full tw-rounded-b-[6px] tw-border tw-border-solid tw-border-[#EFF0F1]"])
    }, [
      (__props.isSearchModalAssessment)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "tw-flex tw-items-center tw-pb-[16px] tw-pt-[21px] tw-px-[16px] tw-cursor-pointer",
            onClick: openSearchModal
          }, [
            _createElementVNode("span", _hoisted_2, [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_unref(getComponentUiText)(
              "app-component-assessments-hover-search-box-assessment-title-1",
            )), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(`tw-pb-[18px] line-height-80 tw-px-[16px] ${
          __props.isSearchModalAssessment ? '' : 'tw-pt-[21px]'
        }`)
      }, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(getComponentUiText)(
            "app-component-assessments-hover-search-box-assessment-recent-search-title-1",
          )), 1)
      ], 2),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listResentSearch.value, (item) => {
          return (_openBlock(), _createElementBlock("p", {
            key: item.id,
            class: "tw-mb-[21px] tw-cursor-pointer",
            onClick: _cache[0] || (_cache[0] = (e) => onClickItemResentSearch(e))
          }, _toDisplayString(item.searchData.text), 1))
        }), 128))
      ]),
      (listResentSearch.value?.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("span", {
              class: "tw-flex tw-text-[#387DFF] tw-text-[12px] tw-not-italic tw-font-[500] tw-leading-[14px] tw-cursor-pointer",
              onClick: clearRecentSearch
            }, _toDisplayString(_unref(getComponentUiText)(
              "app-component-assessments-hover-search-box-clear-search-history-1",
            )), 1)
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})